<template>
  <div>
    <template>
      <v-container>
        <v-tabs v-model="state" slider-color="primary">
          <v-tab :key="'detail'" :href="'#detail'" ripple>Live Detail</v-tab>
          <v-tab :key="'products'" :href="'#products'" ripple>Products</v-tab>
          <!-- <v-tab :key="'orders'" :href="'#orders'" ripple>Order Summary</v-tab> -->
          <!-- <v-tab :key="'cart'" :href="'#cart'" ripple>Cart Management</v-tab> -->
          <v-tab :key="'conversation'" :href="'#conversation'" ripple>Conversation</v-tab>
          <v-tab :key="'payments'" :href="'#payments'" ripple>Payments</v-tab>
          <v-tab :key="'setting'" :href="'#setting'" ripple>Setting</v-tab>
        </v-tabs>
      </v-container>

      <template v-if="state == 'detail'">
        <v-container v-if="!detailloading">
          <div>
            <v-btn
              @click="subtab = 'current'"
              :color="subtab == 'current' ? 'primary' : 'grey'"
              depressed
              :outline="subtab == 'current' ? false : true"
              >Current</v-btn
            >
            <v-btn
              @click="subtab = 'history'"
              :color="subtab == 'history' ? 'primary' : 'grey'"
              depressed
              :outline="subtab == 'history' ? false : true"
              >History</v-btn
            >
          </div>
          <div v-if="subtab == 'current'">
            <v-layout>
              <v-flex>
                <h1 class="headline mb-3">
                  {{ $t('Live Detail') }}
                  <v-chip small v-if="livedata.status == 'draft'">
                    <v-icon small class="mr-2">edit</v-icon>Draft
                  </v-chip>
                  <v-chip small v-else-if="livedata.status == 'live'" color="red" dark>
                    <v-icon small class="mr-2">fiber_manual_record</v-icon>Live
                  </v-chip>
                  <v-chip small v-else-if="livedata.status == 'pause'" color="warning" dark>
                    <v-icon small class="mr-2">pause</v-icon>Pause
                  </v-chip>
                  <v-chip
                    small
                    v-else-if="livedata.status == 'ended'"
                    color="red"
                    dark
                    style="opacity: 0.5"
                  >
                    <v-icon small class="mr-2">stop</v-icon>Stop
                  </v-chip>
                </h1>
              </v-flex>
              <v-flex class="text-xs-right">
                <template v-if="livedata.status == 'draft'">
                  <v-btn
                    :loading="botstatusloading"
                    @click="changeStatus('live')"
                    color="success"
                    depressed
                    :disabled="
                      !intentpostidlist ||
                      !livedata ||
                      (livedata.status == 'ended' && showCreateBtn)
                    "
                  >
                    <v-icon small class="mr-2">play_arrow</v-icon>Start
                  </v-btn>
                </template>
                <template v-else-if="livedata.status == 'live'">
                  <!-- <v-btn @click="changeStatus('')" color="warning" depressed>
                  <v-icon small class="mr-2">pause</v-icon>Pause
                  </v-btn>-->
                  <v-btn
                    :loading="botstatusloading"
                    @click="changeStatus('ended')"
                    color="error"
                    depressed
                  >
                    <v-icon small class="mr-2">stop</v-icon>stop
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn @click="createNew" color="green" outline>Create</v-btn>
                </template>
              </v-flex>
            </v-layout>

            <v-card>
              <v-card-text>
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm5
                    class="form-control px-1"
                    :class="{ 'has-error': errors.has('livename') }"
                  >
                    <label>ชื่อ Live</label>
                    <input
                      ref="inputlivename"
                      v-validate="'required'"
                      name="livename"
                      :readonly="['ended'].includes(livedata.status)"
                      v-model="livedata.name"
                      type="text"
                      placeholder="Live Name"
                    />
                    <span class="text-error" v-if="errors.has('livename')">
                      {{ errors.first('livename') }}
                    </span>
                  </v-flex>

                  <!-- <v-flex xs12 sm4 class="form-control px-1">
                  <input type="text" placeholder="Live Link" />
                  </v-flex>-->

                  <v-flex xs12 sm7 class="text-xs-right">
                    <span v-if="livedata.status != 'ended'" style="display: inline-block">
                      <div>
                        <label>ส่งปุ่มชำระเงินอัตโนมัติ</label>
                      </div>
                      <label class="toggle-switch small">
                        <input
                          @input="changeSendSummary"
                          v-model="livedata.sendcartsummary_status"
                          type="checkbox"
                        />
                        <span class="toggle-slider lever round"></span>
                      </label>
                    </span>
                  </v-flex>
                  <v-flex xs9 sm9 class="px-1">
                    <label>ชื่อโพสต์</label>
                    <div v-if="postdata && postdata.name && postdata.id">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="`https://www.facebook.com/` + postdata.id"
                        >{{ postdata.name }}</a
                      >
                    </div>
                  </v-flex>
                  <v-flex xs3 class="text-xs-right">
                    <span style="display: inline-block; vertical-align: top">
                      <v-btn
                        :disabled="['ended'].includes(livedata.status)"
                        color="primary"
                        outline
                        @click="showSelectPost = true"
                      >
                        <template v-if="postidlist.length == 0">{{ $t('Select post') }}</template>
                        <template v-else>
                          <div>{{ 'Selected(1)' }}</div>
                          <!-- <div>{{postdata.name | truncate(15)}}</div> -->
                        </template>
                        <v-icon class="ml-1">edit</v-icon>
                      </v-btn>
                    </span>
                  </v-flex>

                  <v-flex xs12 class="text-xs-center">
                    <v-btn
                      v-if="!livedata.id || (livedata.status == 'ended' && showCreateBtn)"
                      @click="saveLiveInfo"
                      :loading="saveloading"
                      depressed
                      color="primary"
                      >{{ $t('Create') }}</v-btn
                    >
                    <v-btn
                      v-else-if="!['ended'].includes(livedata.status)"
                      @click="updateLiveInfo"
                      :loading="saveloading"
                      depressed
                      color="primary"
                      >{{ $t('Save') }}</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <div v-if="livedata && livedata.status !== 'draft'" wrap class="mt-3">
              <div>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12 sm6 class="pr-2 py-2">
                    <p class="title primary--text">Cart Management</p>
                    <v-card style="height: 100%">
                      <cart-management></cart-management>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 sm6 class="pl-2 py-2">
                    <p class="title primary--text">Order Summary</p>
                    <v-card style="height: 100%">
                      <order-summary ref="liveordersummary" :liveid="liveid"></order-summary>
                    </v-card>
                  </v-flex>
                </v-layout>
              </div>
              <div style="margin-top: 43px">
                <div>
                  <v-card class="mb-2">
                    <v-card-text>
                      <h1 class="headline primary--text">CF Stat</h1>
                      <div v-if="!chatstatloading" id="chart">
                        <vue-apex-charts
                          ref="chatchart"
                          type="area"
                          height="230"
                          :options="chatstatOptions"
                          :series="chatstatseries"
                        ></vue-apex-charts>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
                <div>
                  <v-card class="mb-2">
                    <v-card-text>
                      <h1 class="headline primary--text">Order Stat</h1>
                      <!-- <div class="text-xs-center">
                    <div class="caption grey--text py-4">No order stat</div>
                      </div>-->
                      <div v-if="!ordersstatloading" id="chart">
                        <vue-apex-charts
                          ref="orderchart"
                          type="area"
                          height="230"
                          :options="orderstatOptions"
                          :series="orderstatseries"
                        ></vue-apex-charts>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </div>
          </div>
          <div v-if="subtab == 'history'">
            <history-live></history-live>
          </div>
          <intent-select-post
            :singleselect="true"
            v-model="intentpostidlist"
            :show="showSelectPost"
            :postdata.sync="postdata"
            @close="showSelectPost = false"
          ></intent-select-post>
        </v-container>
        <div v-else>
          <scale-loader
            :loading="detailloading"
            :color="$vuetify.theme.primary"
            height="45px"
            width="7px"
          ></scale-loader>
        </div>
      </template>
      <template v-else-if="state == 'products'">
        <v-container>
          <products></products>
        </v-container>
      </template>
      <!-- <template v-else-if="state == 'orders'">
        <v-container>
          <h1 class="headline mb-3">Order Summary</h1>
        </v-container>
        <div>
          <order-summary :liveid="liveid"></order-summary>
        </div>
      </template>-->
      <!-- <template v-else-if="state == 'cart'">
        <v-container>
          <h1 class="headline mb-3">Cart Management</h1>
          <cart-management></cart-management>
        </v-container>
      </template>-->
      <template v-else-if="state == 'conversation'">
        <v-container>
          <h1 class="headline">Conversation</h1>
        </v-container>
        <intent :showDefault="false" :filter-context="'live'"></intent>
      </template>
      <template v-else-if="state == 'setting'">
        <v-container>
          <h1 class="headline mb-3">Setting</h1>
          <div>
            <MessagePattern :isSetting="true"></MessagePattern>
          </div>
        </v-container>
      </template>
      <template v-else-if="(state = 'payments')">
        <Payments></Payments>
      </template>
    </template>
  </div>
</template>

<script>
import Products from './Products'
import Payments from '@/components/view/template/ecommerce/Payment.vue'
import Intent from './Intent'
import OrderSummary from './OrderSummary'
import { mapGetters } from 'vuex'
import api from '@/api'
import IntentSelectPost from './IntentSelectPost'
import CartManagement from './CartManagement'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import moment from 'moment'
import MessagePattern from './MessagePattern.vue'
import HistoryLive from './HistoryLive.vue'

import VueApexCharts from 'vue-apexcharts'
import { setInterval, clearInterval } from 'timers'

export default {
  data() {
    return {
      myInterval: '',
      historyid: '',
      data: [],
      liveid: '',
      temppostid: '',
      search: '',
      postdata: { name: '' },
      showCreateBtn: false,
      ordersstatloading: false,
      chatstatloading: false,
      botstatusloading: false,
      toporders: [],
      detailloading: true,
      temp: '',
      saveloading: false,
      intentpostidlist: '',
      showSelectPost: false,
      livedata: {
        name: '',
        status: '',
        sendcartsummary_status: true
      },
      view: 'manage',
      state: 'detail',
      status: 'draft',

      chatstatseries: [],
      orderstatseries: [],
      chatstatOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: 'datetime',
          categories: []
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      },
      orderstatOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: 'datetime',
          categories: []
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      },
      chatstat: '',
      cartData: [],
      subtab: 'current'
    }
  },
  components: {
    IntentSelectPost,
    Intent,
    Products,
    CartManagement,
    VueApexCharts,
    Intent,
    ScaleLoader,
    OrderSummary,
    Payments,
    CartManagement,
    MessagePattern,
    HistoryLive
  },
  computed: {
    ...mapGetters(['selectedBot']),
    postidlist: function () {
      var vm = this
      if (vm.intentpostidlist && vm.intentpostidlist !== '') {
        return vm.intentpostidlist.split(',')
      }
      return []
    }
  },
  async mounted() {
    await this.getDetail()
    if (this.liveid) {
      this.getchatstat()
      this.getorderstat()
    } else {
      this.detailloading = false
    }
    if (this.livedata && this.livedata.postid) {
      this.getPostData(this.livedata.postid)
    }
    if (this.livedata.status == 'live') {
      this.startInterval()
    }
  },
  beforeDestroy() {
    clearInterval(this.myInterval)
  },
  methods: {
    startInterval() {
      this.myInterval = setInterval(() => {
        this.getchatstat()
        this.getorderstat()
      }, 120000)
    },
    getPostData(id) {
      api.getPostData({ postid: id }, (err, response) => {
        var data = response.data
        this.postdata = { name: data.message ? data.message : data.story, ...data }
      })
    },

    saveLiveInfo() {
      var data = {
        pageid: this.selectedBot.pageid,
        name: this.livedata.name,
        postid: this.intentpostidlist
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saveloading = true
          api.postliveinfo(data, (err, response) => {
            this.liveid = response.data[0].id
            this.livedata.id = response.data[0].id
            this.temppostid = this.intentpostidlist
            this.saveloading = false
            // this.$emit('changeview', { view: 'manage', liveid: response.data[0].id })
          })
        }
      })
    },
    updateLiveInfo() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saveloading = true
          api.putliveinfo(
            {
              id: this.livedata.id,
              pageid: this.selectedBot.pageid,
              name: this.livedata.name,
              postid: this.intentpostidlist,
              status: this.livedata.status
            },
            (err, response) => {
              this.saveloading = false
              this.$swal.fire({ type: 'success', title: 'บันทึกสำเร็จ' })
            }
          )
        }
      })
    },
    createNew() {
      this.showCreateBtn = true
      this.intentpostidlist = ''
      this.temppostid = ''
      this.livedata = {
        status: 'draft',
        name: '',
        sendcartsummary_status: true
      }
      try {
        clearInterval(this.myInterval)
      } catch (error) {
        console.log(error)
      }
      // this.$refs.liveordersummary.detroyInterval()
      ;(this.postdata = { name: '' }),
        this.$nextTick(() => {
          this.errors.clear()
          this.$nextTick(() => {
            this.$validator.reset()
          })
        })
    },
    groupTime(data) {
      var result = []
      data.map((el, i) => {
        var mytime = moment(el.timestamp)
        mytime = this.roundownTime(mytime, 15)

        if (
          result.findIndex((v) => {
            return v.timestamp == mytime
          }) != -1
        ) {
          var index = result.findIndex((v) => v.timestamp == mytime)
          result[index].count = result[index].count + 1
        } else {
          result.push({ timestamp: mytime, count: 1 })
        }
      })
      return result
    },
    roundownTime(value, b) {
      let roundedtime = value
      let mymin = Math.floor(moment(value).minute() / b) * b
      let result = moment(roundedtime).minute(mymin).second(0).format('YYYY-MM-DD HH:mm')
      return result
    },
    gettoporderslive() {
      api.gettoporderslive(
        { liveid: this.liveid, pageid: this.selectedBot.pageid },
        (err, response) => {
          if (response.data && response.responsecode == 200) {
            if (response.data) {
              this.toporders = response.data
            } else {
              this.toporders = []
            }
          }
        }
      )
    },
    changeSendSummary(e) {
      var vm = this
      var livedata = { ...this.livedata }
      api.putliveinfo(
        {
          id: livedata.id,
          pageid: this.selectedBot.pageid,
          name: livedata.name,
          postid: this.intentpostidlist,
          status: livedata.status,
          sendcartsummary_status: e.target.checked
        },
        (err, response) => {
          // this.livedata.status = status
        }
      )
    },
    changeStatus(status) {
      var vm = this
      var livedata = { ...this.livedata }
      var title

      if (status == 'live') title = this.$t('คุณต้องการเริ่มบอทใช่หรือไม่?')
      if (status == 'ended') title = this.$t('คุณต้องการปิดบอทใช่หรือไม่?')
      this.$swal
        .fire({
          type: 'question',
          title: title,
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            vm.botstatusloading = true
            if (status == 'live') {
              vm.startInterval()
            }
            api.putliveinfo(
              {
                id: livedata.id,
                pageid: this.selectedBot.pageid,
                name: livedata.name,
                postid: this.intentpostidlist,
                status: status,
                sendcartsummary_status: livedata.sendcartsummary_status
              },
              async (err, response) => {
                vm.botstatusloading = false
                vm.livedata.status = status
                if (status == 'ended') vm.showCreateBtn = false
                if (status == 'live') {
                  await vm.deleteclearcartslive()
                  vm.getchatstat()
                  vm.getorderstat()
                }
              }
            )
          }
        })
    },

    getchatstat() {
      api.getchatstat({ liveid: this.liveid, pageid: this.selectedBot.pageid }, (err, response) => {
        if (response.data && response.responsecode == 200) {
          var groupedTime = this.groupTime(response.data)
          var statdate = groupedTime.map((el) => new Date(el.timestamp).toISOString())
          statdate.unshift(moment(statdate[0]).subtract(15, 'minutes').toDate().toISOString())
          statdate.push(
            moment(statdate[statdate.length - 1])
              .add(15, 'minutes')
              .toDate()
              .toISOString()
          )
          this.chatstatOptions = {
            chart: {
              height: 350,
              type: 'area'
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              curve: 'straight',
              lineCap: 'round'
            },
            xaxis: {
              type: 'datetime',
              categories: statdate
            },
            tooltip: {
              x: {
                format: 'dd/MM/yy HH:mm'
              }
            }
          }
          var statvalue = groupedTime.map((el) => el.count)
          statvalue.unshift(0)
          statvalue.push(0)
          this.chatstatseries = [{ name: 'Message', data: statvalue }]
          if (this.$refs.chatchart) {
            this.$refs.chatchart.updateSeries([{ name: 'Message', data: statvalue }], false, true)
          }
          this.$forceUpdate()
        }
      })
    },
    getorderstat() {
      var vm = this
      // vm.ordersstatloading = true
      api.getorderstat(
        { liveid: this.liveid, pageid: this.selectedBot.pageid },
        (err, response) => {
          // vm.ordersstatloading = false
          if (response.data && response.responsecode == 200) {
            var groupedTime = this.groupTime(response.data)
            var statdate = groupedTime.map((el) => new Date(el.timestamp).toISOString())
            statdate.unshift(moment(statdate[0]).subtract(15, 'minutes').toDate().toISOString())
            statdate.push(
              moment(statdate[statdate.length - 1])
                .add(15, 'minutes')
                .toDate()
                .toISOString()
            )
            this.orderstatOptions = {
              chart: {
                height: 350,
                type: 'area'
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                curve: 'straight'
              },
              xaxis: {
                type: 'datetime',
                categories: statdate
              },
              tooltip: {
                x: {
                  format: 'dd/MM/yy HH:mm'
                }
              }
            }
            var statvalue = groupedTime.map((el) => el.count)

            statvalue.unshift(0)
            statvalue.push(0)
            this.orderstatseries = [{ name: 'Orders', data: statvalue }]
            if (this.$refs.orderchart) {
              this.$refs.orderchart.updateSeries([{ name: 'Orders', data: statvalue }], false, true)
            }
            this.$forceUpdate()
          }
        }
      )
    },
    getDetail() {
      return new Promise((resolve, reject) => {
        this.detailloading = true
        api.getliveinfodetail({ pageid: this.selectedBot.pageid }, (err, response) => {
          // console.log(response.data[0])
          if (response && response.responsecode == 200) {
            this.livedata = response.data[0]
            this.liveid = response.data[0].id
            this.intentpostidlist = response.data[0].postid
            this.temppostid = this.intentpostidlist
          }
          this.detailloading = false
          resolve()
        })
      })
    },
    deleteclearcartslive() {
      var vm = this
      return new Promise((resolve, reject) => {
        this.$swal
          .fire({
            type: 'question',
            title: 'คุณต้องการเคลียร์ตะกร้าทั้งหมดหรือไม่?',
            showCancelButton: true,
            confirmButtonText: vm.$t('Yes'),
            cancelButtonText: vm.$t('No'),
            reverseButtons: true
          })
          .then((result) => {
            if (result.value) {
              api.deleteclearcartslive({ pageid: this.selectedBot.pageid }, (err, response) => {
                this.items = []
                resolve()
              })
            } else {
              resolve()
            }
          })
      })
    },
    onBack() {
      this.$emit('changeview', { view: 'main' })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/live/LiveManagement.vue